import { UnionToTuple } from 'types';
import type { CcmCampaignGender } from 'modules/campaigns/components/ccm/types';
import type { CampaignPackageType } from 'modules/campaigns/components/campaign-package/types';

export const GENDERS_MAP_FROM: { [k: string]: CcmCampaignGender } = {
  women: 'F',
  men: 'M'
};
export const GENDERS_MAP_TO: { [k in CcmCampaignGender]: string } = {
  F: 'women',
  M: 'men'
};

export const PACKAGES_LIST: UnionToTuple<CampaignPackageType> = ['s', 'm', 'l'];
